<app-side-nav-companion-bar pageHeader="Home">
    <h2 title>
        <app-card-actionables [actions]="actions"></app-card-actionables>
        Reading Lists
    </h2>
    <h6 subtitle>{{pagination?.totalItems}} Items</h6>
</app-side-nav-companion-bar>

<app-card-detail-layout
    [isLoading]="loadingLists"
    [items]="lists"
    [actions]="actions"
    [pagination]="pagination"
    [filteringDisabled]="true"
    (pageChange)="onPageChange($event)"
    >
    <ng-template #cardItem let-item let-position="idx">
        <app-card-item [title]="item.title" [entity]="item" [actions]="getActions(item)" [supressLibraryLink]="true" [imageUrl]="imageService.placeholderImage" (clicked)="handleClick(item)"></app-card-item>
    </ng-template>
</app-card-detail-layout>
